import { type Session, type UserInfo } from '~/features/auth/apis/auth'

export type LoginAuthProps = {
  data: {
    userInfo: UserInfo
    session: Session
  }
}

export const setAuthInfo = ({ data }: LoginAuthProps) => {
  const { userInfo, session } = data

  localStorage.setItem('starlike-access-token', session!.accessToken)
  localStorage.setItem('starlike-refresh-token', session!.refreshToken)
  localStorage.setItem('starlike-user-name', userInfo.name)

  return
}

export const removeAuthInfo = () => {
  localStorage.removeItem('starlike-access-token')
  localStorage.removeItem('starlike-refresh-token')
  localStorage.removeItem('starlike-user-name')
  localStorage.removeItem('starlike-login-type')

  return
}
